import styled from "@emotion/styled";

export const CreateTrucksContent = styled.div(({ theme }) => ({
	padding: "1.25rem",
	gap: 16,
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-end",
	"> div:first-of-type": {
		margin: 0,
		width: "100%",
		boxSizing: "border-box"
	},
	"> button": {
		minWidth: "343px"
	},
	[theme.breakpoints.down("md")]: {
		"> button": {
			width: "100%"
		}
	}
}));

export const TrucksErrorBanner = styled.div({
	marginLeft: 12,
	"> div:first-of-type": {
		margin: "0 0 4px",
		paddingLeft: 0
	},
	ul: {
		paddingLeft: 24
	}
});

export const CreateTrucksSkeletonContent = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	width: "100%",
	padding: 16,
	boxSizing: "border-box",
	overflowX: "auto",
	"> div:first-of-type": {
		display: "flex",
		justifyContent: "space-between",
		marginBottom: 24,
		gap: 16,
		span: {
			height: 42
		},
		[theme.breakpoints.down("md")]: {
			flexDirection: "column"
		}
	},
	"> span": {
		marginBottom: 36
	},
	"> div:last-of-type": {
		display: "flex",
		flexDirection: "column",
		gap: 16
	},
	[theme.breakpoints.down("md")]: {
		"> span": {
			display: "none"
		}
	}
}));

export const CreateTrucksSkeletonRow = styled.div({
	display: "grid",
	gridTemplateColumns: "5fr 5fr 5fr 3fr 1fr 1fr 1fr 3fr",
	gap: 22,
	minWidth: 850,
	"> span": {
		height: 36
	},
	"> div": {
		display: "flex",
		flexDirection: "column",
		gap: 8,
		"> span": {
			height: 14
		}
	}
});
